export const MARKDOWN_TYPING_SPEED = 10; // ms per character
